import React, {useEffect, useState} from "react";
import CycleStyles from "../styles/cycles.module.css";
import GenStyles from "../styles/ofb_gen_styles.module.css";

const CycleSubItem = (props) => {
    const [countDown, setCountDown] = useState(null);

    useEffect(() => {
        if(props) {
            if(!props.data['completion_data']) {
                setCountDown('∞');
            } else {
                setCountDown(props.data['frequency'] - props.data['completion_data']['days_elapsed'])
            }
        }
    }, [props])

    return (
        <>
        <div
            className={CycleStyles.todo_simple_item}
            style={!props.active_only ? {marginLeft: (props.data['depth'] - 1) * 20} : {}}
            onClick={() => props.set_selected_item(props.data)}
        >
            {props.data['completed'] ? '✔' : '○'}&nbsp;
            <span className={props.data['completed'] ? GenStyles.strike : ''}>
                <span className={props.data['completion_data']['days_elapsed'] === props.data['frequency']
                    ? GenStyles.yellow :
                    (props.data['completion_data']['days_elapsed'] > props.data['frequency'] ? GenStyles.red : (
                        props.data['completion_data'] === false ? GenStyles.red : ''
                    ))}>
                    {props.data['title']}
                </span> [{countDown}]
            </span>
        </div>
            {!props.active_only && props.data['sub_items'] && props.data['sub_items'].length > 0 && props.data['sub_items'].map((subitem, subitem_index) => (
                <CycleSubItem
                    key={subitem['cycle_item_id']}
                    data={subitem}
                    set_selected_item={props.set_selected_item}
                    today={props.today}
                />
            ))}
        </>
    )
}
export default CycleSubItem;